

































import { Vue, Component, Prop } from 'vue-property-decorator';

import CustomerImportService from '@/api/CustomerImportService';

import CustomerImportIlustraSuccess from '@/components/icons/CustomerImportIlustraSuccess.vue';

let timer: any;
const POLLING_TIME = 1000; // 1s

@Component({
  components: {
    CustomerImportIlustraSuccess
  }
})
export default class CustomerImportSuccess extends Vue {
  @Prop({ default: false }) modal?: boolean;
  @Prop(Number) totalCustomersToImport?: number;
  @Prop() customerImportData!: any;

  customerImportService = new CustomerImportService();
  progress = {
    imported: this.totalCustomersToImport || 0,
    total: this.totalCustomersToImport || 0,
    percentage: 100
  };
  timeRemaining = 5;

  get seconds() {
    return this.timeRemaining <= 1 ? 'second' : 'seconds';
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  customerImportStatus() {
    timer = setInterval(() => {
      this.timeRemaining--;
      if (this.timeRemaining === 0) {
        clearInterval(timer);

        this.$emit('completed', this.customerImportData);
      }
    }, POLLING_TIME);
  }

  mounted() {
    this.customerImportStatus();
  }

  beforeDestroy() {
    clearInterval(timer);
  }
}
